<template>
  <div>
    <div class="row mt-2">
      <div class="col">
        <TitleBreadcrumb :page="header.page" />
      </div>
      <div class="col">
        <div class="row">
          <div class="col-12">
            <div class="d-flex mt-5 justify-content-end">
              <ActionButton
                i="fas fa-arrow-circle-left"
                variant="outline-success m-2"
                @click="goToHistorialPei"
              >
                Regresar
              </ActionButton>
              <ActionButton
                i="fas fa-save"
                variant="success m-2"
                @click="saveAdmendmentSections"
              >
                Guardar
              </ActionButton>

              <router-link to="/pei/history">
                <ActionButton i="fas fa-flag" variant="outline-success m-2">
                  Historial
                </ActionButton>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-divider mt-0 pb-2 w-100" />
    <div class="row mb-4">
      <div class="col">
        <div class="tag-badge-info">
          <span class="tag-badge-title-info pl-3">
            Partes del PEI o PS que se estarán evaluando en esta enmienda:
          </span>
          <p class="mt-2 pl-3">
            Favor de marcar todas las áreas donde se realizarán enmiendas al PEI
            o PS. Para poder enmendar el PEI o PS es obligatorio completar esta
            área.
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="showAlertError"
      id="validation-message"
      class="alert validation-message mb-4"
    >
      <i class="fal fa-exclamation-triangle" />
      <span class="text ml-2">{{ errorMessage }}</span>
    </div>

    <section>
      <content-layout title="Selección (puede marcar más de una opción)">
        <div slot="content">
          <div v-if="this.isAmendmentCorrelationLogicActive" class="panel-row-without-selector checkall">
        <custom-link
              class="mx-3 select show"
              text="Seleccionar todos"
              icon="fas fa-plus"
              @click="select_unselect_All(true)"
              id="btnSelect"
            />

            <custom-link
              class="mx-3 unselect hide"
              text="Remover todas la selección"
              icon="fas fa-minus"
              @click="select_unselect_All(false)"
              id="btnUnselect"
             />
      </div>
          <row
            v-for="option in sections"
            :section="option"
            :id="option.id"
            :key="option.id"
            :ref="'section_' + option.id"
            :suboptions="option.suboptions"
            :text="option.text"
            :services="servicesStudents"
            :isAmendmentCorrelationLogicActive="isAmendmentCorrelationLogicActive"
            @getSectionService="getSectionService"
            @setLogicBySelection="setLogicBySelection"
            @subOptionSelected="subOptionSelected"
            @select_unselect_All="select_unselect_All"
          />
        </div>
        <button class="btn btn-action btn-green">
          <i class="fas fa-save" />
          Guardar
        </button>
      </content-layout>
    </section>
  </div>
</template>

<script>
import Row from "./Row";
// import options from "./resources/options";
import ContentLayout from "./layouts/ContentLayout";
import store from "@/store/index";

import TitleBreadcrumb from "@/components/common/page/TitleBreadcrumb";
import ActionButton from "@/components/common/ActionButton";
import PeiServices from "@/services/pei/general";
import AlertMixin from "@/mixin/alert.mixin";
import sectionAmendment from "@/utils/constants/pei/sectionAmendment";
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("$_admendment");
import {
  CustomLink,
} from '@/components/common';
export default {
  name: "AmendmentView",
  data() {
    return {
      header: {
        buttons: [
          {
            icon: "arrow-circle-left",
            name: "Regresar",
            click: () => {},
            bgTransparent: false
          },
          {
            icon: "save",
            name: "Guardar",
            click: () => {},
            bgTransparent: false
          },
          {
            icon: "clock",
            name: "Completar",
            click: () => {},
            bgTransparent: true
          }
        ],
        page: {
          icon: "fas fa-user-edit",
          title: "Parte a evaluar en la Enmienda",
          routes: ["Inicio", "PEI", "Parte a evaluar en la Enmienda"]
        },
        subPage: {
          icon: "fas fa-user-edit",
          title: "Razones para revisar el PEI fuera del término establecido"
        }
      },
      sections: [],
      showAlertError: false,
      errorMessage: "",
      peiId: 0,
      userId: 0,
      type: "PS",
      servicesSelectedStudent: [],
      servicesStudents: [],
      serviceIdSelected: 42,
      selectedSubOption: [],
      isAmendmentCorrelationLogicActive: false,
      agencyParticipation: 45,
      familyParticipation: 46,
      gradeA: 33
    };
  },
  mixins: [AlertMixin],
  components: {
    ContentLayout,
    Row,
    TitleBreadcrumb,
    ActionButton,
    CustomLink
  },
  async mounted() {
    const { data } = await getSysparameterByNames({
      parameterNames: ["AllowedAmendmentCorrelationLogic"],
      academicYearId: store.state.pei?.academicYearId // pei academic year id
    });

    if(data && data.length > 0){
      this.isAmendmentCorrelationLogicActive = data[0].staticValue==="true";
    }

    this.peiId = store.state.peiSelected;
    this.type =
      store.state.pei.configUnilateralFlag == false ? "PEI" : this.type;
    this.userId = store.state.userProfile.sub;
    const servicesStudents = await PeiServices.getallanalysisservice(
      this.peiId
    );
    this.servicesStudents = servicesStudents.map(item => ({
      serviceName: item.service,
      id: item.analysisServiceId,
      peiAnalysisServiceCode: item.peiAnalysisServiceCode,
      selected: false,
      selectedYes: null,
      selectedNo: null
    }));

    this.sections = await this.getAmendments(this.peiId);
  },
  methods: {
    ...mapActions(["getPeiAdmendment", "getCorrelationParameter","getPartEvaluationAmendmentServiceById"]),
    async getAmendments(peiId) {
      let sections = await PeiServices.getAmendmentSections(peiId);
      return sections.map(function(section) {
        let sectionChilds = [];
        if (section.childs != null) {
          sectionChilds = section.childs.map(function(option) {
            const optionDto = {
              id: option.id,
              text: `${option.name}. ${option.description}`,
              readOnly: false
            };
            return optionDto;
          });
        }

        let sectionDto = {
          id: String(section.id),
          text: `${section.name}. ${section.description}`,
          selected: false,
          readOnly: false,
          suboptions: sectionChilds
        };

        return sectionDto;
      });
    },
    goToHistorialPei() {
      this.$router.push({ path: "/pei/history" });
    },
    async saveAdmendmentSections() {
      this.showAlertError = false;
      const dtoService = [];
      let amendmentsDTO = this.getAdmendmentMap();
      if (amendmentsDTO.length == 0) {
        this.errorMessage =
          "Favor de seleccionar las partes a evaluar en la enmienda del " +
          this.type +
          ".";
        this.showAlertError = true;
      } else {
        let i = 0;

        while (i < amendmentsDTO.length && !this.showAlertError) {
          if (
            (amendmentsDTO[i].hasSubSections == true &&
              amendmentsDTO[i].selectedSubSectionsid.length == 0) ||
            (amendmentsDTO[i].sectionId == sectionAmendment.viii &&
              amendmentsDTO[i].selectedSubSectionsid.includes(
                this.serviceIdSelected
              ) &&
              this.servicesSelectedStudent.filter(x => x.selected).length ===
                0 &&
              this.isAmendmentCorrelationLogicActive)
          ) {
            this.errorMessage = `Favor de seleccionar las secciones a evaluar en la parte ${amendmentsDTO[i].text}`;
            this.showAlertError = true;
          }
          i++;
        }

        const selectedServices = this.servicesSelectedStudent.filter(
          x => x.selected
        );
        selectedServices.forEach(element => {
          if (element.selectedYes == null && element.selectedNO == null){
            this.errorMessage = `Favor de seleccionar las secciones a evaluar y/ó preguntas en la parte  ${ this.sections[6].text}`;
            this.showAlertError = true;
          } else {
            dtoService.push({
              peiId: this.peiId.toString(),
              serviceId: element.peiAnalysisServiceCode,
              changeRelatedTransportationServiceFlag: element.selectedYes
            });
          }
        });
      }

      //Save in backend
      if (!this.showAlertError) {
        let apiDTO = {
          peiId: this.peiId.toString(),
          userId: this.userId,
          Sections: [],
          ServicesStudent: dtoService
        };

        //Populate selected subsections
        amendmentsDTO.forEach(elementArr => {
          apiDTO.Sections.push({
            SectionId: elementArr.sectionId,
            SelectedSubSectionsid: elementArr.selectedSubSectionsid
          });
        });
        await PeiServices.saveAdmendmentSections(apiDTO);
        this.getPeiAdmendment(this.peiId.toString());
        this.getPartEvaluationAmendmentServiceById(this.peiId.toString());
        this.getCorrelationParameter();
        this.$router.push({ path: "/pei/detail?amendmentSuccess=true" });
      }
    },
    select_unselect_All(val) {
      if(val == true)
      {
        $( "#btnSelect" ).removeClass( "show" );
        $( "#btnSelect" ).addClass( "hide" );
        $( "#btnUnselect" ).removeClass( "hide" );
        $( "#btnUnselect" ).addClass( "show" );
      }
      else
      {
        $( "#btnSelect" ).removeClass( "hide" );
        $( "#btnSelect" ).addClass( "show" );
        $( "#btnUnselect" ).removeClass( "show" );
        $( "#btnUnselect" ).addClass( "hide" );
      }

      this.sections[sectionAmendment.sectionI].selected = val;
      this.sections[sectionAmendment.sectionII].selected = val;
      this.sections[sectionAmendment.sectionIII].selected = val;
      this.sections[sectionAmendment.sectionIII].suboptions.forEach(
              option => {
                const refName = `section_${sectionAmendment.iii}`;
                this.$refs[refName][0].selectElement(option.id);
                option.readOnly = true;
              }
            );
      this.sections[sectionAmendment.sectionIVV].selected = val;
      
      this.sections[sectionAmendment.sectionVI].selected = val;
      this.sections[sectionAmendment.sectionVI].suboptions.forEach(
          option => {
            const refName = `section_${sectionAmendment.vi}`;
            this.$refs[refName][0].selectElement(option.id);
            option.readOnly = true;
          }
        );

      this.sections[sectionAmendment.sectionVII].selected = val;

      this.sections[sectionAmendment.sectionVIII].selected = val;
      this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
          option => {
            const refName = `section_${sectionAmendment.viii}`;
            this.$refs[refName][0].selectElement(option.id);
            option.readOnly = true;
          }
        );

    this.sections[sectionAmendment.sectionIX].selected = val;
    this.sections[sectionAmendment.sectionIX].suboptions.forEach(
              option => {
                  const refName = `section_${sectionAmendment.ix}`;
                  this.$refs[refName][0].selectElement(option.id);
                  option.readOnly = true;
              }
            );

    this.sections[sectionAmendment.sectionX].selected = val;
    this.sections[sectionAmendment.sectionXI].selected = val;
    this.sections[sectionAmendment.sectionXII].selected = val; 
    this.sections[sectionAmendment.sectionXIII].selected = val;
    },

    getSectionService(services) {
      this.servicesSelectedStudent = services;
    },
    getAdmendmentMap() {
      let amendments = [];

      this.sections.forEach(section => {
        const element = this.getSection(section.id);
        let sectionElement = section;
        if (sectionElement.selected) {
          let elementArr = {
            peiId: this.peiId,
            sectionId: sectionElement.id,
            selectedSubSectionsid: [],
            text: sectionElement.text,
            hasSubSections: sectionElement.suboptions.length > 0
          };
          element.selectedOptions.forEach(optionId => {
            elementArr.selectedSubSectionsid.push(optionId);
          });
          amendments.push(elementArr);
        }
      });
      return amendments;
    },
    setLogicBySelection(val) {
      if (!this.isAmendmentCorrelationLogicActive) {
        return;
      }
      this.logicSelection(val.value);
    },
    logicSelection(value) {
      switch (value.id) {
        case sectionAmendment.i:
          if (value.selected) {
            this.sections[sectionAmendment.sectionIVV].readOnly = true;
            this.sections[sectionAmendment.sectionIVV].selected = true;
            this.sections[sectionAmendment.sectionVIII].readOnly = true;
            this.sections[sectionAmendment.sectionVIII].selected = true;
            this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
              option => {
                const refName = `section_${sectionAmendment.viii}`;
                this.$refs[refName][0].selectElement(option.id);
                option.readOnly = true;
              }
            );
            this.applyLogicTabIV(value.selected);
          } else {
            this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
              option => {
                if (option.id != this.serviceIdSelected)
                  option.readOnly = false;
              }
            );

            if (!this.sections[sectionAmendment.sectionII].selected) {
              this.sections[sectionAmendment.sectionIVV].readOnly = false;
              this.sections[sectionAmendment.sectionIVV].selected = false;
              this.sections[sectionAmendment.sectionVIII].readOnly = false;
              this.applyLogicTabIV(value.selected);
            }
          }

          break;
        case sectionAmendment.ii:
          if (value.selected) {
            this.sections[sectionAmendment.sectionVIII].readOnly = true;
            this.sections[sectionAmendment.sectionVIII].selected = true;
            const refName = `section_${sectionAmendment.viii}`;
            this.$refs[refName][0].selectElement(this.serviceIdSelected);
            this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
              option => {
                if (option.id === this.serviceIdSelected) {
                  option.readOnly = true;
                  this.sections[sectionAmendment.sectionIVV].readOnly = true;
                  this.sections[sectionAmendment.sectionIVV].selected = true;
                }
              }
            );
          } else {
            this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
              option => {
                option.readOnly = false;
              }
            );

            if (!this.sections[sectionAmendment.sectionI].selected) {
              this.sections[sectionAmendment.sectionIVV].readOnly = false;
              this.sections[sectionAmendment.sectionIVV].selected = false;
              this.sections[sectionAmendment.sectionVIII].readOnly = false;
              this.sections[sectionAmendment.sectionVIII].selected = false;
            }
          }
          break;
        case sectionAmendment.ivv:
          this.applyLogicTabIV(value.selected);
          break;
        case sectionAmendment.vi: {
          if (
            !value.selected &&
            this.sections[sectionAmendment.sectionVIII].readOnly &&
            !(
              this.sections[sectionAmendment.sectionIVV].selected ||
              this.sections[sectionAmendment.sectionII].selected
            )
          ) {
            this.sections[sectionAmendment.sectionVIII].readOnly = false;
            this.sections[sectionAmendment.sectionVIII].selected = false;
          } else if (
            !value.selected &&
            this.sections[sectionAmendment.sectionVIII].readOnly &&
            this.sections[sectionAmendment.sectionIVV].selected &&
            !(
              this.sections[sectionAmendment.sectionI].selected ||
              this.sections[sectionAmendment.sectionII].selected
            )
          ) {
            this.sections[sectionAmendment.sectionIVV].readOnly = false;
            this.sections[sectionAmendment.sectionIVV].selected = false;
            this.sections[sectionAmendment.sectionVIII].readOnly = false;
            this.sections[sectionAmendment.sectionVIII].selected = false;

            this.sections[
              sectionAmendment.sectionVIII
            ].suboptions = this.sections[
              sectionAmendment.sectionVIII
            ].suboptions.map(c => {
              return {
                ...c,
                readOnly: false
              };
            });
          }
          break;
        }
        case sectionAmendment.viii: {
          if (!value.selected) {
            this.sections[sectionAmendment.sectionIVV].readOnly = false;
            this.sections[sectionAmendment.sectionIVV].selected = false;
          }
          break;
        }
        case sectionAmendment.ix: {
          if (!value.selected) {
            this.sections[sectionAmendment.sectionXIII].readOnly = false;
            this.sections[sectionAmendment.sectionXIII].selected = false;
          }
          break;
        }
        case sectionAmendment.xiii:
          if (value.selected) {
            this.sections[sectionAmendment.sectionIX].readOnly = true;
            this.sections[sectionAmendment.sectionIX].selected = true;
            this.sections[sectionAmendment.sectionIX].suboptions.forEach(
              option => {
                if (option.id == this.agencyParticipation) {
                  const refName = `section_${sectionAmendment.ix}`;
                  this.$refs[refName][0].selectElement(option.id);
                  option.readOnly = true;
                }
              }
            );
          } else {
            this.sections[sectionAmendment.sectionIX].suboptions.forEach(
              option => {
                if (option.id == this.agencyParticipation) {
                  option.readOnly = false;
                  option.selected = false;
                }
              }
            );

            this.sections[sectionAmendment.sectionIX].readOnly = false;

            if (
              !this.sections[sectionAmendment.sectionIX].suboptions.find(
                c => c.id == this.familyParticipation
              ).selected
            ) {
              this.sections[sectionAmendment.sectionIX].selected = false;
            }
          }
          break;
      }
    },
    subOptionSelected(val) {
      if (!this.isAmendmentCorrelationLogicActive) {
        return;
      }
      switch (val.id) {
        case sectionAmendment.vi:
          if (val.optionThatGenerateEvent == this.gradeA) {
            if (val.options.some(c => c == this.gradeA)) {
              this.sections[sectionAmendment.sectionVIII].readOnly = true;
              this.sections[sectionAmendment.sectionVIII].selected = true;
              this.sections[sectionAmendment.sectionIVV].readOnly = true;
              this.sections[sectionAmendment.sectionIVV].selected = true;

              const refName = `section_${sectionAmendment.viii}`;
              this.$refs[refName][0].selectElement(this.serviceIdSelected);

              this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
                option => {
                  if (option.id === this.serviceIdSelected) {
                    option.readOnly = true;
                  }
                }
              );
            } else if (
              !(
                this.sections[sectionAmendment.sectionI].selected ||
                this.sections[sectionAmendment.sectionII].selected
              )
            ) {
              this.sections[sectionAmendment.sectionVIII].readOnly = false;
              this.sections[sectionAmendment.sectionVIII].selected = false;
              this.sections[sectionAmendment.sectionIVV].readOnly = false;
              this.sections[sectionAmendment.sectionIVV].selected = false;
              this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
                option => {
                  if (option.id === this.serviceIdSelected) {
                    option.readOnly = false;
                    option.selected = false;
                  }
                }
              );
            }
          }

          break;
        case sectionAmendment.viii:
          if (val.options.some(c => c == this.serviceIdSelected)) {
            this.sections[sectionAmendment.sectionIVV].readOnly = true;
            this.sections[sectionAmendment.sectionIVV].selected = true;
          } else {
            this.sections[sectionAmendment.sectionIVV].readOnly = false;
            this.sections[sectionAmendment.sectionIVV].selected = false;
          }
          if (val.options.length == 0) {
            this.sections[sectionAmendment.sectionIVV].readOnly = false;
            this.sections[sectionAmendment.sectionIVV].selected = false;
          }
          break;
        case sectionAmendment.ix:
          if (val.options.some(c => c == this.agencyParticipation)) {
            if (
              !this.sections[sectionAmendment.sectionIX].suboptions.find(
                c => c.id == this.agencyParticipation
              ).readOnly
            ) {
              this.sections[sectionAmendment.sectionXIII].readOnly = true;
              this.sections[sectionAmendment.sectionXIII].selected = true;
            }
          } else {
            this.sections[sectionAmendment.sectionXIII].readOnly = false;
            this.sections[sectionAmendment.sectionXIII].selected = false;
          }
          break;
      }
    },
    getSection(id) {
      if (this.$refs["section_" + id] != null) {
        return this.$refs["section_" + id][0];
      }
      return null;
    },
    applyLogicTabIV(selected) {
      if (selected) {
        this.sections[sectionAmendment.sectionVIII].readOnly = true;
        this.sections[sectionAmendment.sectionVIII].selected = true;
        this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
          option => {
            const refName = `section_${sectionAmendment.viii}`;
            this.$refs[refName][0].selectElement(option.id);
            option.readOnly = true;
          }
        );
      } else {
        this.sections[sectionAmendment.sectionVIII].readOnly = false;
        this.sections[sectionAmendment.sectionVIII].selected = false;
        this.sections[sectionAmendment.sectionVIII].suboptions.forEach(
          option => {
            option.readOnly = false;
            option.selected = false;
          }
        );
      }
    },

  }
};
</script>

<style scope>
.subtext {
  font-size: 0.9em;
  margin-left: 15px;
}

.container-subtext {
  margin-top: 10px;
}
.tag-badge-info p {
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
#validation-message {
  margin-top: 20px;
  border: 1px solid #ff5b5c;
  background: #ffebeb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  font-weight: normal;
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #ff5b5c;
  opacity: 1;
}

#validation-message .text {
  padding-left: 10px;
}
.checkall
{
  display: flex;
  padding: 15px;
  font-weight: bold;
  background-color: #EBFAF2;
  color: #2DB782;
}
.hide{
  display: none !important;
}
.show{
  display: block !important;
}
</style>
